import { ProgressBar, ProgressText, Text, Title, Wrapper } from './cardSkeleton.styles'
import { CardSkeletonProps } from './cardSkeleton.types'

const CardSkeleton = ({ progress }: CardSkeletonProps) => {
  return (
    <Wrapper className="_border _border-gray-300 _rounded-lg _p-4" role="status" aria-busy="true">
      <Title className="_rounded-pill _mb-2" />
      <Text className="_rounded-pill" />

      {progress && (
        <div className="_pt-6">
          <ProgressText className="_rounded-pill _mb-2" />
          <ProgressBar className="_rounded-pill" />
        </div>
      )}
    </Wrapper>
  )
}

export default CardSkeleton
